













import Vue from "vue";
import Component from "vue-class-component";
import { Model, Prop } from "vue-property-decorator";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { $t } from "@/lib/i18nHelpers";
import { printPaymentPackage } from "@/lib/moneyHelpers";
import config from "@/config";
import { FormFields, FormValues, ListFields } from "@/types";
import BaseForm from "@/components/BaseForm";
import WelcomeMessageEditor from "@/components/WelcomeMessageEditor";

@Component({ name: "PriceLevelEditForm", components: { BaseForm, WelcomeMessageEditor } })
export default class PriceLevelEditForm extends Vue {
  @Model("input", { required: true })
  public values!: FormValues;

  @Prop({ required: true })
  public readonly paymentPackages!: PaymentPackage[];

  @Prop({ default: "" })
  public pricePackageIdHint!: string;

  @Prop()
  public priceLevelId!: string;

  get isWelcomeMessageOn(): boolean {
    return config.featureWelcomeMessage;
  }

  get fields(): FormFields {
    return [
      {
        name: "pricePackageId",
        label: $t("Price per month"),
        type: "select",
        options: this.subscriptionPrices,
        hint: this.pricePackageIdHint,
      },
      {
        name: "description",
        placeholder: $t("Caption"),
        type: "textarea",
        style: { height: "137px" },
        hint: $t("Tell what kind of content your fans get buying this subscription level access"),
      },
      ...(config.featureWelcomeMessage
        ? [
            {
              name: "messageEditor",
              placeholder: $t("Welcome message for subscribing"),
              label: $t("Welcome message for subscribing"),
            },
          ]
        : []),
    ];
  }

  get subscriptionPrices(): ListFields {
    return this.paymentPackages.map(item => ({
      value: item.id,
      text: printPaymentPackage(item),
    }));
  }
}
